export default __webpack_public_path__ + "static/media/Myriad Pro Italic.7c1eba45.ttf";